import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable} from 'rxjs';
import { AuthService } from '../modulos/auth/services/auth.service';
import { Store, select } from '@ngrx/store';
import { AppState } from '../app.reducer';
import { Aplicacion } from '../models/usuario.model';
import { getAplicacionesUsuarioPorAmbiente, tieneAplicacionUsuarioPorAmbiente } from '../redux/usuario/usuario.selectors';

@Injectable({
  providedIn: 'root'
})
export class AccessPermisionGuard implements CanActivate {

  aplicaciones: Aplicacion[];

  constructor(
    private store: Store<AppState>,
    private router: Router) { 
      this.store.select(getAplicacionesUsuarioPorAmbiente).subscribe((response)=>{
        this.aplicaciones = response        
      })
      
    }

  /**
   * TODO: Pentiente validar en el selector si tiene aplicaciones desde un array de aplicaciones, ya que se está verificando solo desde la posición cero
   * @param route parametros de la ruta
   * @param state estado de petición
   * @returns 
   */

  canActivate(
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot) : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree{              

    let redirect =  false;
    if(route.data.apps){  
      this.store.pipe(select(tieneAplicacionUsuarioPorAmbiente,{app:route.data.apps})).subscribe(response=>{
        redirect = response
      })
    }
    return redirect || this.router.createUrlTree(['/pagina403']);    
  }
}